import React, { useEffect, useRef, useState } from "react";
import "../../styles.scss";
import "remixicon/fonts/remixicon.css"; // Import Remix Icon CSS
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useUser } from "../../utils/userContext";
import useHandleErrors from "../../utils/user.utils";
import Select from 'react-select';
import moment from "moment";

const AssignAsset = () => {
    const [assetSerialNumber, setAssetSerialNumber] = useState("");
    const [assignedAssets, setAssignedAssets] = useState([]);
    const [assetType, setAssetType] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedAssetID, setSelectedAssetID] = useState("");
    const [loading, setLoading] = useState(false);
    const empId = localStorage.getItem("EmployeeId");
    const empName = localStorage.getItem("EmployeeName");
    const empEmail = localStorage.getItem("OfficialEmail");
    const empAssignDate = localStorage.getItem("DateOfJoining");
    const [assignDate, setAssignDate] = useState(empAssignDate);
    const { user } = useUser();
    const handleErrors = useHandleErrors();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);


    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    useEffect(() => {
        if (!hasFetchedRef.current) {
            getAssetList();
            hasFetchedRef.current = true;
        }
    }, []);

    const getAssetList = async () => {
        setLoading(true);
        try {
            const path = "/getAssetReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const result = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (result.status === 200) {
                console.log("result", result.data); 
                if (!result.data.RegisterAssets || result.data.RegisterAssets.length === 0) {
                    setAssetList([]); // Set an empty array if no assets are returned
                    return;
                }
    
                const activeAssets = result.data.RegisterAssets.filter(asset => 
                    asset.Status.toLowerCase() === 'active'
                );
                setAssetList(activeAssets);
            } else if (result.status === 404) {
                setAssetList([]); // Handle 404 by setting an empty list
            } else {
                handleErrors(result); // Handle other non-200 responses
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setAssetList([]); // Handle 404 error in catch block
                } else {
                    handleErrors(error.response); // Pass other errors to the handler
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };    

    const handleAssign = () => {
        if (
            !selectedCategory ||
            !selectedAssetID ||
            !assetSerialNumber ||
            !assignDate ||
            !assetType
        ) {
            toast.info("Please fill in all required fields.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        const newAsset = {
            assetCategory: selectedCategory,
            assetID: selectedAssetID,
            assetSerialNumber,
            assignDate,
            assetType,
        };
        setAssignedAssets([...assignedAssets, newAsset]);
        setSelectedCategory("");
        setSelectedAssetID("");
        setAssetSerialNumber("");
        setAssignDate("");
        setAssetType("")
    };

    const handleDelete = (index) => {
        const newAssignedAssets = [...assignedAssets];
        newAssignedAssets.splice(index, 1);
        setAssignedAssets(newAssignedAssets);
    };

    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption ? selectedOption.value : '');
        setSelectedAssetID("");
        setAssetSerialNumber("");
    };

    const handleAssetIDChange = (selectedOption) => {
        setSelectedAssetID(selectedOption ? selectedOption.value : '');
        const asset = assetList.find((asset) => asset.AssetId === selectedOption.value);
        setAssetSerialNumber(asset?.SerialNumber || "");
    };

    const handleAssetTypeChange = (selectedOption) => {
        setAssetType(selectedOption ? selectedOption.value : '');
    };

    const handleNext = async () => {
        setLoading(true);
        const payload = {
            EmployeeId: empId,
            EmployeeName: empEmail,
            EmployeeOfficialEmail: empEmail,
            // NoOfAssets: assignedAssets?.length,
            NoOfAssets: `${assignedAssets.length}`,
            UpdatedBy: user?.FirstName,
            AssetList: assignedAssets.map((asset) => ({
                AssetId: asset.assetID,
                CategoryType: asset.assetCategory,
                AssignDate: asset.assignDate,
                SerialNumber: asset.assetSerialNumber,
                AssignmentType: asset.assetType,
            })),
            Status: "Assigned",
            ActiveFlag: "Y",
            AssetStatus: "Insert",
        };
        try {
            const path = "/assignAsset";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                toast.success("Assets assigned successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                navigate("/welcomekit");
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setSelectedCategory("");
        setSelectedAssetID("");
        setAssetSerialNumber("");
        setAssignDate("");
        setAssignedAssets([])
        setAssetType("")
    };
    const handleSkip = () => {
        localStorage.setItem("Skipped", "Skipped");
        navigate("/welcomekit")
    };

    const categoryOptions = [
        ...new Set(assetList.map(asset => asset.CategoryType))
    ].map(category => ({
        value: category,
        label: category,
    }));

    const assetOptions = assetList
        .filter(asset => asset.CategoryType === selectedCategory)
        .map(asset => ({
            value: asset.AssetId,
            label: asset.AssetId,
        }));

    const assetTypeOptions = [
        { value: 'In Courier', label: 'In Courier' },
        { value: 'In Person', label: 'In Person' },
        { value: 'Online', label: 'Online' },
        { value: 'Offline', label: 'Offline' },
        { value: 'Electronic', label: 'Electronic' },
        { value: 'Others', label: 'Others' },
    ];

    const ClearIndicator = () => null;

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Onboard Employee</h3>
                        </div>
                        <div className="col-auto">
                            <Link
                                to={'/Employees'}
                                data-extra-toggle="tab"
                                data-target="#organisation-pan"
                                className="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i className="ri-user-star-line"></i> View All Employees
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-1">
                            <div className="circle-tab-wrapper">
                                <ul className="nav nav-tabs circle-tab" role="tablist">
                                    <li className="nav-item step-done">
                                        <a
                                            className="nav-link"
                                            title="Employee Information"
                                            rel="tooltip"
                                            role="tab"
                                        >
                                            <i className="ri-user-shared-fill"></i>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            data-toggle="tab"
                                            title="Assign Asset"
                                            rel="tooltip"
                                            role="tab"
                                        >
                                            <i className="ri-list-check-3"></i>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            title="Welcome Kit?"
                                            rel="tooltip"
                                            role="tab"
                                        >
                                            <i className="ri-shapes-line"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-11">
                            <div>
                                <div className="tab-pane" id="assign-asset" role="tabpanel">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card mb-4">
                                                <div className="card-body" id="assignAssetDetails">
                                                    <h5
                                                        className="title accordion-title"
                                                        data-toggle="collapse"
                                                        data-target="#assignAsset"
                                                    >
                                                        Assign Asset
                                                    </h5>
                                                    <div
                                                        className="collapse show"
                                                        id="assignAsset"
                                                        data-parent="#assignAssetDetails"
                                                    >
                                                        <div className="row">
                                                            <div className="form-group col-md-4">
                                                                <label htmlFor="aaempid">Employee ID</label>
                                                                <input
                                                                    type="text"
                                                                    readOnly
                                                                    className="form-control"
                                                                    value={empId}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label htmlFor="assdate">Employee Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    readOnly
                                                                    value={empName}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label htmlFor="aaoemail">Official Email</label>
                                                                <input
                                                                    type="email"
                                                                    readOnly
                                                                    className="form-control"
                                                                    value={empEmail}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="table-responsive asset-information">
                                                                    <table className="table grid">
                                                                        <thead className="bg-light">
                                                                            <tr>
                                                                                <th width="20%">Category</th>
                                                                                <th width="20%">ID</th>
                                                                                <th width="20%">Serial Number</th>
                                                                                <th width="20%">Assign Date</th>
                                                                                <th width="20%">Assign Type</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <Select
                                                                                        className="react-select-container"
                                                                                        classNamePrefix="react-select"
                                                                                        name="CategoryType"
                                                                                        value={categoryOptions.find(option => option.value === selectedCategory) || null}
                                                                                        onChange={handleCategoryChange}
                                                                                        options={categoryOptions}
                                                                                        components={{ ClearIndicator }}
                                                                                        isClearable
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        className="react-select-container"
                                                                                        classNamePrefix="react-select"
                                                                                        name="AssetId"
                                                                                        value={assetOptions.find(option => option.value === selectedAssetID) || null}
                                                                                        onChange={handleAssetIDChange}
                                                                                        options={assetOptions}
                                                                                        isDisabled={!selectedCategory}
                                                                                        components={{ ClearIndicator }}
                                                                                        isClearable
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        readOnly
                                                                                        value={assetSerialNumber}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        value={assignDate}
                                                                                        onChange={(e) =>
                                                                                            setAssignDate(e.target.value)
                                                                                        }
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        className="react-select-container"
                                                                                        classNamePrefix="react-select"
                                                                                        name="assetType"
                                                                                        value={assetTypeOptions.find(option => option.value === assetType) || null}
                                                                                        onChange={handleAssetTypeChange}
                                                                                        options={assetTypeOptions}
                                                                                        components={{ ClearIndicator }}
                                                                                        isClearable
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <button
                                                                                        className="btn btn-secondary btn-action"
                                                                                        type="button"
                                                                                        title="Assign"
                                                                                        onClick={handleAssign}
                                                                                    >
                                                                                        <i className="ri-checkbox-circle-line"></i>{" "}
                                                                                        Assign
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <small className="form-text text-muted text-center mt-0">
                                                                        <i className="ri-information-2-line"></i>{" "}
                                                                        Multiple assets can be assigned
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col">
                                                            <h5 className="title mt-1 mb-0">Asset Summary</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-md-12">
                                                            <div className="table-responsive asset-information">
                                                                <table className="table grid">
                                                                    <thead className="bg-light">
                                                                        <tr>
                                                                            <th width="30">S.No.</th>
                                                                            <th>Category</th>
                                                                            <th>ID</th>
                                                                            <th>Serial Number</th>
                                                                            <th>Assign Date</th>
                                                                            <th>Assign Type</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {assignedAssets.map((asset, index) => (
                                                                            <tr key={index}>
                                                                                <td>
                                                                                    {String(index + 1).padStart(2, "0")}
                                                                                </td>
                                                                                <td>{asset.assetCategory}</td>
                                                                                <td>{asset.assetID}</td>
                                                                                <td>{asset.assetSerialNumber}</td>
                                                                                <td>{asset.assignDate}</td>
                                                                                <td>{asset.assetType}</td>
                                                                                <td className="text-center">
                                                                                    <button
                                                                                        className="btn btn-link text-danger btn-action"
                                                                                        type="button"
                                                                                        title="Delete"
                                                                                        onClick={() => handleDelete(index)}
                                                                                    >
                                                                                        <i className="ri-delete-bin-6-line"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center ONBsecondTab">
                    <button
                        className="btn btn-light btnPrevious"
                        type="button"
                        onClick={handleReset}
                    >
                        <i className="ri-arrow-left-circle-line"></i> Reset
                    </button>
                    <button
                        className="btn btn-light btn-secondary"
                        type="button"
                        onClick={handleSkip}
                    >
                        <i class="ri-close-circle-fill" /> Skip
                    </button>
                    <button
                        className="btn btn-primary btnNext"
                        type="button"
                        onClick={handleNext}
                    >
                        Next <i className="ri-checkbox-circle-line"></i>
                    </button>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default AssignAsset;
